// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__QVYq+","content":"styles_content__n4h4k","row":"styles_row__Hp9Fu"};